import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import { isEmpty, get, find } from 'lodash';

import { Profile } from 'api/api-profile';
import { Fees } from '../../../api/api-fees';
import Payments from '../../../api/api-payments';
import Contracts from '../../../api/api-contracts';
import { getWebEnv } from '../../../api/api-env';
import { Metrics } from '../../../api/api-metrics';
import ReviewSpaceRentalTable from '../elements-tables/review-space-rental-table';
import AddOnsTable from '../app-main/components/reduxForms/fieldSets/AddOnsTable/add-ons-table';
import ReviewOfferForm from './forms/ReviewOfferForm';
import { getShowBillingForm, verifyPSCredits } from '../app-bookings-request/forms/bookingUtil';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { paymentErrors } from '../app-bookings-current-details/data/payment-data';
import { stripeErrorHandler } from "shared-components/stripe/stripeErrorHandler";
import { fetchContractsSnapshot } from '../app-main/actions/contracts';
import { REVIEW_OFFER_FORM } from '../app-main/components/reduxForms/constants/formNames';

class ReviewOfferGuestView extends Component {
  constructor (props) {
    super(props);

    this.state = {
      paymentInfo: false,
      selectedPayment: '',
      displayError: '',
      isProcessing: false,
      credits: {},
      creditsFetched: false,
      applyCreditProcessing: false,
      creditsApplied: null,
      remainingGuestTotal: null,
      currentPaidTotal: null,
      noAddtlPaymentNeeded: false,
      refundedAmount: null,
      socialEventsPolicyCopy: '',
      guestNeedsVerification: false,
      remainingSplitPaymentRequired: false
    };

    this.fetchCardData = this.fetchCardData.bind(this);
    this.handleListClickCb = this.handleListClickCb.bind(this);
    this.paymentActionFn = this.paymentActionFn.bind(this);
    this.storeCardInstance = this.storeCardInstance.bind(this);
    this.createStripeToken = this.createStripeToken.bind(this);
    this.acceptOffer = this.acceptOffer.bind(this);
    this.acceptOfferCb = this.acceptOfferCb.bind(this);
    this.handleDeclineOfferClick = this.handleDeclineOfferClick.bind(this);
    this.handleApplyCreditChange = this.handleApplyCreditChange.bind(this);
    this.getPaymentQuote = this.getPaymentQuote.bind(this);
    this.getIDVInfo = this.getIDVInfo.bind(this);
    this.submitBillingAddress = this.submitBillingAddress.bind(this);
    this.handleBillingCountryChange = this.handleBillingCountryChange.bind(this);
    this.handleBillingSubRegionChange = this.handleBillingSubRegionChange.bind(this);
    this.updateGuestBillingForOfferReview = this.updateGuestBillingForOfferReview.bind(this);
    this.submitUpdateBillingAddress = this.submitUpdateBillingAddress.bind(this);
  }

  componentDidMount () {
    const { accessToken, ssoId, socialEventPolicyAgreementRequired } = this.props;

    if (accessToken) {
      this.fetchCardData((err, res) => {
        // *
        //  * If error occurs, we handle gracefully
        //  * and act as if there is no payment info on file,
        //  * still giving the user the option to fill out
        //  * new payment info.
        let selectedPayment = false;
        let paymentInfo = [];

        if (res && Array.isArray(res) && 0 < res.length) {
          paymentInfo = res;
          selectedPayment = res[0];
        }

        this.setState({
          paymentInfo,
          selectedPayment
        });
      });

      if (ssoId) {
        Profile.readCredits(ssoId, accessToken, (response) => {
          if (200 === response.statusCode) {
            this.setState({ credits: response });
          }
          this.setState({ creditsFetched: true });
          this.getPaymentQuote(false);
        });

        // the initial value of alcohol_consumed is `undefined`
        // because the toggle isn't selected
        this.getIDVInfo(undefined);
      }
    }

    const locale = SharedIntlProviderHOC.getLocale();
    if (socialEventPolicyAgreementRequired) {
      getWebEnv(locale, (env) => {
        this.setState({
          socialEventsPolicyCopy: env.social_events_policy
        });
      })
    }
  }

  // NOTE: alcoholConsumed value comes from child component ReviewOfferForm
  // This fn is passed as a callback to ReviewOfferForm
  getIDVInfo (alcoholConsumed) {
    const { accessToken, ssoId, contracts, booking } = this.props;
    const alcohol_consumed = alcoholConsumed === 'true';
    const listingId = get(this.props, 'booking.listing_id', '');
    const schedule = get(this.props, 'booking.schedule', []);
    const activity = PSSessions.Cookies.get('saved-activity');

    // Booking isn't updated locally in stsate when alcohol is toggled,
    // updating it here so we can calculate risk correctly.
    const updatedBooking = {
      ...booking,
      alcohol_consumed
    };

    const payload = {
      sso_id: ssoId,
      listing_id: listingId,
      alcohol_consumed,
      schedule,
      booking: updatedBooking,
      activity
    };

    return Metrics.identityVerification(payload, accessToken, (res) => {
      const guestNeedsVerification = get(res, 'data.guest_needs_verification', false);
      const risk_score = get(res, 'data.metadata.risk_score', null);

      this.setState({
        guestNeedsVerification,
        riskScore: risk_score
      });
    });
  }

  fetchCardData (cb) {
    const { ssoId, accessToken } = this.props;
    Payments.getCustomerData(ssoId, accessToken, (res) => {
      if (400 === res.statusCode) {
        return cb(res.error);
      }
      return cb(false, res.data);
    });
  }

  handleListClickCb (data, cb) {
    this.setState({
      selectedPayment: JSON.parse(data)
    }, cb);
  }

  paymentActionFn (datum) {
    this.setState(datum);
  }

  storeCardInstance (card, stripe) {
    this.setState({
      newCard: card,
      stripe
    });
  }

  createStripeToken (cardholders_name, cb) {
    const { newCard, stripe } = this.state;
    stripe.createToken(newCard, {
      name: cardholders_name
    }).then(cb);
  }

  getPaymentQuote (applyCreditValue) {
    const { credits } = this.state;
    const { accessToken, booking, isHostUpdate, total, updateDifference, contracts } = this.props;
    const paymentTotal = isHostUpdate ? updateDifference.additional_payment : total;
    const creditBalance = applyCreditValue ? get(credits, 'balance', 0) : 0;
    const spaceRental = find(contracts, { type: 'SPACE_RENTAL' }) || {};
    const country = get(spaceRental, 'meta.listing.country', 'US');

    // the control_id is included in the payload for custom offers only, so BE can provide information on
    // previous payments, ie. if the offer came from a request and there is a captured charge.
    // until we can use that functionality for host updates too (we are currently using 'calculations.update_difference'
    // for addtl payment & refund, and this call purely for ps credits & total due calculations), we will send the
    // country instead, so the BE can determine if credits are allowed in the listing area.

    const payload = {
      total: paymentTotal,
      guest_payment_ps_credit_amount: creditBalance,
      control_id: booking._id
    }

    Contracts.creditPaymentQuote(payload, accessToken, (res) => {
      const remainingSplitPaymentRequired = get(res, 'remaining_sp_payment_required', false);
      if (remainingSplitPaymentRequired) {
        this.setState({ remainingSplitPaymentRequired });
      }
      const suggestedCredit = get(res, 'guest_payment_method_details.suggested');
      if (applyCreditValue && suggestedCredit) {
        return this.setState({
          creditsApplied: suggestedCredit.subtotal_ps_credit,
          remainingGuestTotal: suggestedCredit.subtotal_remaining,
          currentPaidTotal: res.current_paid_total,
          applyCreditProcessing: false
        })
      }

      if (200 === res.statusCode) {
        return this.setState({
          creditsApplied: get(res, 'guest_payment_method_details.subtotal_ps_credit', 0),
          remainingGuestTotal: get(res, 'guest_payment_method_details.subtotal_remaining', 0),
          noAddtlPaymentNeeded: res.no_additional_payment_needed,
          refundedAmount: res.no_additional_payment_needed ? get(res, 'guest_payment_method_details.total', 0) : null,
          currentPaidTotal: res.current_paid_total,
          applyCreditProcessing: false
        })
      }
    })
  }

  handleApplyCreditChange (event, applyCreditValue) {
    this.setState ({ applyCreditProcessing: true });
    this.getPaymentQuote(applyCreditValue);
  }

  handleDeclineOfferClick (e) {
    e.preventDefault();
    const { toggleModal } = this.props;

    return toggleModal('confirmDeclineOfferModal');
  }

  acceptOffer (values, submitCb) {
    const {
      accessToken,
      ssoId,
      acceptOfferAction,
      isHostUpdate,
      toggleModal,
      intl,
      billingCountryValue,
      billingStateValue,
      billingCityValue,
      billingStreetValue,
      billingUnitValue,
      billingZipValue,
      showBillingForm
    } = this.props;
    const { selectedPayment, creditsApplied } = this.state;
    const { alcohol_consumed, cardholders_name, guest_social_events_policy_accepted,
      are_host_rules_accepted } = values;
    const payload = {
      alcohol_consumed: 'true' === alcohol_consumed,
      guest_payment_ps_credit_amount: creditsApplied,
      guest_social_events_policy_accepted,
      are_host_rules_accepted,
      fc_token: window.fcToken
    };

    this.setState({ isProcessing: true });

    let billingAddressPayload = {
      sso_id: ssoId,
      type: 'BILLING',
      obj_state: 'ACTIVE',
      country: billingCountryValue,
      state: billingStateValue,
      city: billingCityValue,
      street: billingStreetValue,
      unit: billingUnitValue,
      zip: billingZipValue
    };

    if (showBillingForm) {
      Fees.createBillingAddress(accessToken, ssoId, billingAddressPayload, response => {
        if (200 !== response.statusCode) {
          return this.setState({ isProcessing: false });
        }
      });
    }

    if (selectedPayment) {
      // existing card
      payload.guest_payment_card_id = selectedPayment.id;
      payload.guest_payment_customer_id = selectedPayment.customer;

      return acceptOfferAction(payload, submitCb, isHostUpdate, billingAddressPayload);
    }

    // create new token
    return this.createStripeToken(cardholders_name, (tokenRes) => {
      this.setState({ isProcessing: true, isDisableSpinning: false });

      if (tokenRes.error) {
        this.setState({ isProcessing: false });
        return toggleModal('paymentErrorModal', tokenRes.error.message);
      }

      // new card token
      const { token } = tokenRes;
      const cardToken = token.id;

      // add card to Payments API.
      const locale = SharedIntlProviderHOC.getLocale();
      return Payments.addCard(locale, ssoId, accessToken, cardToken, (res) => {
        const { error, statusCode } = res;

        if (error || 400 < statusCode) {
          const errorHead = res.error.errorCode
              ? intl.formatMessage(paymentErrors[res.error.errorCode])
              : res.error.message;

          const apiError = res.error.errorCode && intl.formatMessage(paymentErrors[res.error.errorCode]);
          const stripeRawErr = get(error, 'raw.code', null);
          const stripeRawDeclineErr = get(error, 'raw.decline_code', null);
          const stripeErrObj = stripeErrorHandler(stripeRawDeclineErr || stripeRawErr);
          const stripeRawMsg = !isEmpty(stripeErrObj) ? intl.formatMessage({ ...stripeErrObj }) : null;
          const errorBody = apiError || stripeRawMsg || null;

          const errorMessage = { errorHead: errorHead, errorBody: errorBody };

          this.setState({ isProcessing: false });
          return toggleModal('paymentErrorModal', errorMessage);
        }

        payload.guest_payment_card_id = res.id;
        payload.guest_payment_customer_id = res.customer;
        return acceptOfferAction(payload, submitCb, isHostUpdate, billingAddressPayload);
      });
    });
  }

  acceptOfferCb (response, billing = {}) {
    const {
      contracts,
      checkCCState
    } = this.props;

    if (200 === response.statusCode) {
      const spaceRental = find(contracts, { type: 'SPACE_RENTAL' }) || {};
      const spaceRentalBooking = get(spaceRental, 'meta.booking', {});
      spaceRentalBooking.listing = get(spaceRental, 'meta.listing', {});
      analyticsIntegrations.acceptCustomOfferConfirmed(spaceRentalBooking, contracts, billing);

      return checkCCState();
    } else {
      this.setState({
        displayError: true,
        isProcessing: false
      });
    }
  }

  updateGuestBillingForOfferReview () {
    const { accessToken, booking, dispatch } = this.props;
    const bookingId = get(booking, '_id');
    Contracts.updateGuestBillingForOfferReview(
      accessToken,
      bookingId,
      (response) => {
        if (200 === response.statusCode) {
          dispatch(fetchContractsSnapshot(bookingId, accessToken));
        }
      }
    );
  }

  submitBillingAddress (billingAddressPayload) {
    const { ssoId, accessToken } = this.props;
    Fees.createBillingAddress(
      accessToken,
      ssoId,
      billingAddressPayload,
      (response) => {
        if (200 === response.statusCode) {
          this.updateGuestBillingForOfferReview();
        }
      }
    );
  }

  handleBillingCountryChange(e, val) {
    const { dispatch } = this.props;
    const {
      profile,
      billingCityValue,
      billingStreetValue,
      billingUnitValue,
      billingZipValue
    } = this.props;
    const billingCountry = val;

    dispatch(change(REVIEW_OFFER_FORM, 'billing_state', ''));

    const billingAddressPayload = {
      sso_id: profile.SSOid,
      type: 'BILLING',
      country: billingCountry,
      state: '',
      city: billingCityValue,
      street: billingStreetValue,
      unit: billingUnitValue,
      zip: billingZipValue
    };

    this.submitBillingAddress(billingAddressPayload);
  }

  handleBillingSubRegionChange(e, val) {
    const {
      profile,
      billingCountryValue,
      billingCityValue,
      billingStreetValue,
      billingUnitValue,
      billingZipValue
    } = this.props;
    const billingState = val;

    let billingAddressPayload = {
      sso_id: profile.SSOid,
      type: 'BILLING',
      country: billingCountryValue,
      state: billingState,
      city: billingCityValue,
      street: billingStreetValue,
      unit: billingUnitValue,
      zip: billingZipValue
    };

    this.submitBillingAddress(billingAddressPayload);
  }

  submitUpdateBillingAddress () {
    const {
      profile,
      auth,
      billingCountryValue,
      billingStateValue,
      billingCityValue,
      billingStreetValue,
      billingUnitValue,
      billingZipValue
    } = this.props;

    Fees.createBillingAddress(
      auth.accessToken,
      profile.SSOid,
      {
        sso_id: profile.SSOid,
        type: 'BILLING',
        country: billingCountryValue,
        state: billingStateValue,
        city: billingCityValue,
        street: billingStreetValue,
        unit: billingUnitValue,
        zip: billingZipValue
      },
      (response) => {
        if (200 !== response.statusCode) {
          console.log('ERROR WHEN UPDATING BILLING INFORMATION');
        }
      }
    );
  }

  render () {
    const {
      booking,
      cleaningFee,
      currency,
      itemsArray,
      addOnsTotal,
      subtotal,
      total,
      ssoId,
      redirectToInboxDetails,
      accessToken,
      masterContract,
      contractBooking,
      discounts,
      snapshotPending,
      iosWebView,
      scrollTopIOS,
      closeIOSModal,
      updateDifference,
      currentBookingTotal,
      isHostUpdate,
      routeParams,
      finalCb,
      contracts,
      spaceRentalSubtotal,
      spaceRentalTotal,
      guestFee,
      whichModal,
      paymentErrorMsg,
      toggleModal,
      declineOfferAction,
      socialEventPolicyAgreementRequired,
      feeProfiles,
      genericError,
      allCountries,
      globalCountries,
      profile,
      spaces,
      isSplitPayment,
      splitPaymentFee
    } = this.props;

    const {
      displayError,
      selectedPayment,
      paymentInfo,
      isProcessing,
      credits,
      applyCreditProcessing,
      remainingGuestTotal,
      creditsApplied,
      noAddtlPaymentNeeded,
      currentPaidTotal,
      refundedAmount,
      socialEventsPolicyCopy,
      guestNeedsVerification,
      getIdentityValue,
      alcoholConsumed,
      riskScore,
      remainingSplitPaymentRequired
    } = this.state;

    const creditBalance = get(credits, 'balance', 0);
    const listing = get(booking, 'listing', {});
    const psCreditsAllowed = verifyPSCredits(listing);

    const billingAddress = get(feeProfiles, 'billingAddress.data', []);
    const displayBillingDropdown = getShowBillingForm(billingAddress);

    const locale = SharedIntlProviderHOC.getLocale();
    const schedule = get(this.props, 'booking.schedule', []);

    return (
      <div className="tables">
        <div className="note-from-host">
          <div className="label margin-md-bottom">
            <FormattedMessage
              id='inbox_review_offer.review_offer_guest_view.note'
              defaultMessage='Note from the host'
            />
          </div>
          <p>{contractBooking.booking_use_message || ''}</p>
        </div>
        <ReviewSpaceRentalTable
          cleaningFee={cleaningFee}
          currency={currency}
          subtotal={spaceRentalSubtotal}
          total={spaceRentalTotal}
          masterContract={masterContract}
        />

        {!isEmpty(itemsArray) &&
        <AddOnsTable
          isReviewPage
          addOnsTotal={addOnsTotal}
          itemsArray={itemsArray}
          currency={currency}
          masterContract={masterContract}
          ssoId={ssoId}
          whichModal={whichModal}
          toggleModal={toggleModal}
          iosWebView={iosWebView}
          guestView
        />
        }

        <ReviewOfferForm
          currency={currency}
          spaceRentalTotal={spaceRentalTotal}
          total={total}
          accessToken={accessToken}
          ssoId={ssoId}
          booking={booking}
          redirectToInboxDetails={redirectToInboxDetails}
          acceptOffer={this.acceptOffer}
          acceptOfferCb={this.acceptOfferCb}
          guestFee={guestFee}
          discounts={discounts}
          snapshotPending={snapshotPending}
          iosWebView={iosWebView}
          scrollTopIOS={scrollTopIOS}
          closeIOSModal={closeIOSModal}
          updateDifference={updateDifference}
          currentBookingTotal={currentBookingTotal}
          isHostUpdate={isHostUpdate}
          routeParams={routeParams}
          finalCb={finalCb}
          itemsArray={itemsArray}
          contracts={contracts}
          whichModal={whichModal}
          paymentErrorMsg={paymentErrorMsg}
          displayError={displayError}
          selectedPayment={selectedPayment}
          paymentInfo={paymentInfo}
          isProcessing={isProcessing}
          toggleModal={toggleModal}
          handleListClickCb={this.handleListClickCb}
          storeCardInstance={this.storeCardInstance}
          paymentActionFn={this.paymentActionFn}
          getIDVInfo={this.getIDVInfo}
          handleDeclineOfferClick={this.handleDeclineOfferClick}
          declineOfferAction={declineOfferAction}
          creditBalance={creditBalance}
          applyCreditProcessing={applyCreditProcessing}
          handleApplyCreditChange={this.handleApplyCreditChange}
          creditsApplied={creditsApplied}
          remainingGuestTotal={remainingGuestTotal}
          noAddtlPaymentNeeded={noAddtlPaymentNeeded}
          refundedAmount={refundedAmount}
          currentPaidTotal={currentPaidTotal}
          psCreditsAllowed={psCreditsAllowed}
          socialEventPolicyAgreementRequired={socialEventPolicyAgreementRequired}
          socialEventsPolicyCopy={socialEventsPolicyCopy}
          listing={listing}
          guestNeedsVerification={guestNeedsVerification}
          getIdentityValue={getIdentityValue}
          alcoholConsumed={alcoholConsumed}
          feeProfiles={feeProfiles}
          displayBillingDropdown={displayBillingDropdown}
          genericError={genericError}
          allCountries={allCountries}
          globalCountries={globalCountries}
          spaces={spaces}
          locale={locale}
          schedule={schedule}
          riskScore={riskScore}
          remainingSplitPaymentRequired={remainingSplitPaymentRequired}
          isSplitPayment={isSplitPayment}
          splitPaymentFee={splitPaymentFee}
          handleBillingCountryChange={this.handleBillingCountryChange}
          handleBillingSubRegionChange={this.handleBillingSubRegionChange}
          masterContract={masterContract}
        />
      </div>
    );
  }
}

ReviewOfferGuestView.propTypes = {
  cleaningFee: PropTypes.string,
  booking: PropTypes.object,
  currency: PropTypes.string,
  acceptOfferAction: PropTypes.func,
  redirectToInboxDetails: PropTypes.func,
  subtotal: PropTypes.number,
  total: PropTypes.number,
  itemsArray: PropTypes.array,
  ssoId: PropTypes.string,
  addOnsTotal: PropTypes.number,
  accessToken: PropTypes.string,
  declineOfferAction: PropTypes.func,
  masterContract: PropTypes.object,
  contractBooking: PropTypes.object,
  discounts: PropTypes.array,
  whichModal: PropTypes.string,
  toggleModal: PropTypes.func,
  iosWebView: PropTypes.bool,
  closeIOSModal: PropTypes.func,
  snapshotPending: PropTypes.array,
  scrollTopIOS: PropTypes.func,
  updateDifference: PropTypes.object,
  currentBookingTotal: PropTypes.number,
  isHostUpdate: PropTypes.bool,
  routeParams: PropTypes.object,
  finalCb: PropTypes.func,
  contracts: PropTypes.array,
  spaceRentalSubtotal: PropTypes.number,
  spaceRentalTotal: PropTypes.number,
  guestFee: PropTypes.number,
  socialEventPolicyAgreementRequired: PropTypes.bool,
  allCountries: PropTypes.array,
  isSplitPayment: PropTypes.bool,
  splitPaymentFee: PropTypes.number
};

export default injectIntl(ReviewOfferGuestView);
